import { addMonths, startOfMonth } from 'owa-datetime';
import * as React from 'react';
import { MiniCalendar } from './MiniCalendar';
import { MonthViewSettings } from '..';

export function MiniCalendars(props: MonthViewSettings) {
    const { date } = props;
    const currentMonth = startOfMonth(date);
    const nextMonth = addMonths(currentMonth, 1);

    return (
        <>
            <MiniCalendar {...props} date={currentMonth} />
            <MiniCalendar {...props} date={nextMonth} />
        </>
    );
}
